import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Paper,
  Divider,
} from "@mui/material";

export default function OnboardingSnapshot({
  open,
  onClose,
  onContinue,
  onBack,
}) {
  return (
    <Dialog open={open} maxWidth="md" fullWidth disableEscapeKeyDown>
      <DialogTitle>
        <Box sx={{ textAlign: "center", pt: 2 }}>
          <Typography variant="h4" gutterBottom>
            How Downstream Works
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            A simple overview before activation
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            How It Works
          </Typography>

          <List sx={{ py: 0 }}>
            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="1. Students complete brief reflection surveys, embedded in your course"
              />
            </ListItem>

            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="2. Downstream combines survey responses with Canvas activity data for you"
              />
            </ListItem>

            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="3. You receive clear, actionable insights through your dashboard"
              />
            </ListItem>
          </List>
        </Box>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Important Information
          </Typography>

          <Box component="ul" sx={{ pl: 3, 
            "& li": {
              mb: 1,
            },
          }}>
            <li>
              Downstream is designed to support instruction—not evaluate instructors or students.
            </li>
            <li>
              Insights are intended to inform teaching decisions and student support, not replace your professional judgment.
            </li>
            <li>
              You choose the start and end weeks; surveys are automatically created and spaced evenly within that window.
            </li>
            <li>
              Downstream reflection surveys are created as 0-point Canvas quizzes by default, but you're free to change the point value to fit your grading approach.
            </li>
            <li>
              You can remove any survey from your course at any time.
            </li>
          </Box>
        </Box>

        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            borderRadius: 2,
            bgcolor: "grey.100",
          }}
        >
          <Typography variant="h6" gutterBottom>
            Activate Downstream in Your Course
          </Typography>

          <List sx={{ py: 0 }}>
            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="Set Notification Preferences"
                secondary="Decide how and when you would like to receive updates and alerts."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>

            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="Choose Your Survey Schedule"
                secondary="Select the start and end weeks for your reflection surveys."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>

            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="Review and Accept the Data Use Agreement"
                secondary="This allows Downstream to deploy surveys and analyze course data."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            

            <ListItem sx={{ py: 0.5 }}>
              <ListItemText
                sx={{ my: 0 }}
                primary="Explore Your Dashboard"
                secondary="Downstream will add surveys to your Canvas course, begin collecting data, and populate your instructor dashboard."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
          </List>
        </Paper>
      </DialogContent>

      <DialogActions sx={{ p: 3, justifyContent: "space-between" }}>
        <Button onClick={onBack} color="inherit">
          Back
        </Button>

        <Button
          variant="contained"
          onClick={onContinue}
          sx={{
            minWidth: 180,
            background: "linear-gradient(135deg, #2FA4C7, #5DBB3A)",
            color: "#fff",
            "&:hover": {
              background: "linear-gradient(135deg, #1F8FA3, #4FA52F)",
            },
          }}
        >
          Activate
        </Button>
      </DialogActions>
    </Dialog>
  );
}